import { defineStore } from '@sunrise/pinia'

import { Tuple } from '../../service/realEstateService.interface'
import { PeriodOfLeaseText, PeriodRentLabel } from './detailStoreModule.enum'
import {
    DetailStore,
    PeriodOfLease,
    PeriodRentFieldInfoText,
    RequiredPeriodRentData,
} from './detailStoreModule.interface'

export const useDetailStore = defineStore('detailStore', {
    state: (): DetailStore => ({
        exposeeId: null,
        offerType: null,
        estateType: null,
        contactInfo: null,
        periodRentFieldInfoText: null,
    }),
    actions: {
        addPeriodRentTuple(periodRentTuple: Tuple[]) {
            this.periodRentFieldInfoText = buildFieldInfoText(periodRentTuple)
        },
    },
})

function buildFieldInfoText(periodRentTuple: Tuple[]): PeriodRentFieldInfoText {
    if (!periodRentTuple) {
        return {
            availability: PeriodOfLeaseText.NO_INFO,
            periodOfLease: PeriodOfLeaseText.NO_INFO,
        }
    }

    const periodRentData = findRequiredDataIn(periodRentTuple)

    return {
        availability: buildAvailabilityText(periodRentData.from, periodRentData.to),
        periodOfLease: buildPeriodOfLeaseText(periodRentData.lease),
    }
}

function findRequiredDataIn(tuple: Tuple[]): RequiredPeriodRentData {
    const periodRentData: RequiredPeriodRentData = {
        from: undefined,
        to: undefined,
        lease: {
            min: undefined,
            max: undefined,
        },
    }

    tuple.forEach((item: Tuple) => {
        if (item.label === PeriodRentLabel.AVAILABLE_FROM) {
            periodRentData.from = item.value
        }

        if (item.label === PeriodRentLabel.AVAILABLE_TO) {
            periodRentData.to = item.value
        }

        if (item.label === PeriodRentLabel.LEASE_MIN) {
            periodRentData.lease.min = item.value
        }

        if (item.label === PeriodRentLabel.LEASE_MAX) {
            periodRentData.lease.max = item.value
        }
    })
    return periodRentData
}

function buildAvailabilityText(from?: string, to?: string): string {
    if (!from && !to) {
        return PeriodOfLeaseText.NO_INFO
    }

    if (from && to) {
        return `${from} - ${to}`
    }

    const prefix = from ? PeriodOfLeaseText.FROM_PREFIX : PeriodOfLeaseText.TO_PREFIX
    const date = from || to

    return `${prefix} ${date}`
}

function buildPeriodOfLeaseText(lease: PeriodOfLease): string {
    if (!lease.min && !lease.max) {
        return PeriodOfLeaseText.NO_INFO
    }

    if (lease.min && lease.max) {
        return `${lease.min} - ${lease.max}`
    }

    const prefix = lease.min ? PeriodOfLeaseText.MIN_PREFIX : PeriodOfLeaseText.MAX_PREFIX
    const amountOfMonths = lease.min || lease.max

    return `${prefix} ${amountOfMonths}`
}
